/**
 * 로그인이 필요 없는 요청에 쓰는 axios 인스턴스.
 *
 * 로그인 전에 부르는 것들이 여기를 쓴다. 아이디 중복 확인, 본인 인증, 비밀번호 찾기,
 * 그리고 첫 화면의 배너·공지처럼 누구나 볼 수 있는 데이터다.
 * 토큰 갱신(`login/renewAccessToken.ts`)도 이 인스턴스를 쓴다.
 *
 * 주의 두 가지가 있다.
 * 1. 이 파일은 `pages/api/` 안에 있지만 서버에서 도는 코드가 아니다.
 *    정적 내보내기라 서버가 없고, 실제로는 브라우저에서 불리는 보통 모듈이다.
 * 2. 요청 헤더에 토큰을 붙이지 않고, 401 이 와도 토큰을 갱신하지 않는다.
 *    로그인이 필요한 요청에 이것을 쓰면 인증이 안 된 채로 나가니 `axiosInstance.ts` 를 써야 한다.
 *    쿠키는 함께 보낸다(`withCredentials`). 토큰 갱신이 쿠키로 이뤄지기 때문이다.
 */
import axios from "axios";
import { getApiBaseUrl } from "@/utils/getApiBaseUrl";

const publicApi = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
});

publicApi.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터: 오류 발생 시 처리 가능 (
publicApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API 요청 오류:", error);
    return Promise.reject(error);
  }
);

export default publicApi;
